import React from 'react';

const Contact = () => {
    return (
       <div>
          <h1>Contact</h1>
           <p>contact page body content</p>
		   <p>Address: <br />
		   		317 S Broadway #21
				Los Angeles, CA 90013
		   </p>
		   <p>Phone: 714-810-6228 </p>
		   <p>Email: hello@wishcams.com</p>
		   <p>Twitter: @wishcams</p>
       </div>
    );
}

export default Contact;


// WEBPACK FOOTER //
// ./src/components/pages/Contact.js